export interface Article {
  id: string;
  slug: string;
  title: string;
  excerpt: string;
  content: string;
  category: string;
  categorySlug: string;
  image: string;
  author: string;
  publishDate: string;
  readTime: string;
  tags: string[];
  rating: number;
}

export const articles: Article[] = [
  {
    id: '1',
    slug: 'french-butter-complete-guide',
    title: '法国进口黄油完全指南：从伊斯尼到总统，哪款最值得入手？',
    excerpt: '法国黄油以其浓郁的奶香和细腻的口感闻名全球。本文深度评测伊斯尼、总统、铁塔等6款主流法国进口黄油，从发酵工艺、乳脂含量到实际烘焙表现进行全面对比，帮你选出最适合的那一款。',
    content: '',
    category: '进口黄油推荐',
    categorySlug: 'imported-butter',
    image: 'https://readdy.ai/api/search-image?query=Premium%20French%20butter%20blocks%20on%20a%20wooden%20board%20with%20fresh%20bread%20and%20herbs%2C%20warm%20natural%20lighting%2C%20rustic%20french%20kitchen%20setting%2C%20cream%20and%20golden%20color%20palette%2C%20soft%20shadows%2C%20gourmet%20food%20photography%20style%2C%20minimalist%20composition%2C%20elegant%20presentation&width=800&height=500&seq=article-french-butter&orientation=landscape',
    author: '黄油君',
    publishDate: '2026-08-05',
    readTime: '8',
    tags: ['法国黄油', '进口黄油', '发酵黄油', '烘焙黄油'],
    rating: 4.8,
  },
  {
    id: '2',
    slug: 'fermented-butter-taste-test',
    title: '发酵黄油 vs 普通黄油：风味差异与选购建议',
    excerpt: '发酵黄油近年来在国内烘焙圈越来越火，它和普通黄油到底有什么不同？我们实测了5款热门发酵黄油，从香气、口感、烘焙效果三个维度深度对比，帮你搞清楚值不值得多花钱买发酵黄油。',
    content: '',
    category: '发酵黄油推荐',
    categorySlug: 'fermented-butter',
    image: 'https://readdy.ai/api/search-image?query=Artisan%20fermented%20cultured%20butter%20being%20spread%20on%20warm%20sourdough%20bread%2C%20rich%20creamy%20texture%20visible%2C%20natural%20lighting%2C%20warm%20cream%20and%20golden%20tones%2C%20food%20photography%20with%20shallow%20depth%20of%20field%2C%20minimalist%20wooden%20table%20setting&width=800&height=500&seq=article-fermented-butter&orientation=landscape',
    author: '黄油君',
    publishDate: '2026-08-03',
    readTime: '6',
    tags: ['发酵黄油', '黄油对比', '烘焙技巧'],
    rating: 4.6,
  },
  {
    id: '3',
    slug: 'home-baking-butter-selection',
    title: '家庭烘焙用什么黄油好？从入门到进阶的选购方案',
    excerpt: '做饼干、蛋糕、面包，不同烘焙场景对黄油的要求完全不同。本文为零基础家庭烘焙爱好者量身定制，按预算和用途推荐从平价到高端的黄油选择方案，让你少花冤枉钱。',
    content: '',
    category: '烘焙黄油推荐',
    categorySlug: 'baking-butter',
    image: 'https://readdy.ai/api/search-image?query=Home%20baking%20scene%20with%20butter%20cookies%20and%20cake%20on%20cooling%20rack%2C%20butter%20block%20nearby%2C%20warm%20kitchen%20ambient%20light%2C%20cozy%20home%20bakery%20atmosphere%2C%20cream%20and%20soft%20beige%20tones%2C%20lifestyle%20food%20photography&width=800&height=500&seq=article-baking-butter&orientation=landscape',
    author: '黄油君',
    publishDate: '2026-08-01',
    readTime: '7',
    tags: ['家用黄油', '烘焙入门', '黄油选购'],
    rating: 4.7,
  },
  {
    id: '4',
    slug: 'new-zealand-butter-review',
    title: '新西兰黄油深度评测：安佳、威士兰、纽麦福横向对比',
    excerpt: '新西兰是全球最大的黄油出口国之一，其草饲黄油以纯净品质著称。我们对比评测了安佳、威士兰和纽麦福三款主流新西兰黄油，从奶源、工艺到实际口感逐一分析。',
    content: '',
    category: '进口黄油推荐',
    categorySlug: 'imported-butter',
    image: 'https://readdy.ai/api/search-image?query=New%20Zealand%20grass%20fed%20butter%20blocks%20on%20marble%20surface%20with%20green%20pasture%20background%20blur%2C%20clean%20natural%20lighting%2C%20fresh%20dairy%20aesthetic%2C%20cream%20and%20soft%20green%20tones%2C%20premium%20food%20photography%20style&width=800&height=500&seq=article-nz-butter&orientation=landscape',
    author: '黄油君',
    publishDate: '2026-07-28',
    readTime: '7',
    tags: ['新西兰黄油', '进口黄油', '草饲黄油'],
    rating: 4.5,
  },
  {
    id: '5',
    slug: 'butter-brand-comparison-2026',
    title: '2026黄油品牌大横评：12款热门黄油全方位对比',
    excerpt: '我们从乳脂含量、发酵工艺、产地、价格和实际口感五个维度，对市面上12款最热门的黄油品牌进行了全方位横向对比。无论你是烘焙达人还是厨房新手，这份评测都能帮你做出明智选择。',
    content: '',
    category: '黄油品牌对比',
    categorySlug: 'brand-comparison',
    image: 'https://readdy.ai/api/search-image?query=Twelve%20different%20butter%20brands%20arranged%20in%20a%20grid%20on%20a%20light%20wooden%20table%2C%20each%20with%20small%20tasting%20portion%2C%20neutral%20cream%20background%2C%20clean%20product%20photography%20style%2C%20even%20lighting%2C%20organized%20comparison%20layout&width=800&height=500&seq=article-brand-compare&orientation=landscape',
    author: '黄油君',
    publishDate: '2026-07-25',
    readTime: '12',
    tags: ['黄油品牌', '品牌对比', '选购指南', '黄油推荐'],
    rating: 4.9,
  },
  {
    id: '6',
    slug: 'japanese-butter-guide',
    title: '日本黄油选购指南：四叶草、雪印、明治谁更胜一筹？',
    excerpt: '日本黄油以细腻的口感和严格的品控在亚洲市场占据重要地位。本文带您了解日本黄油的特点，对比四叶草、雪印和明治三大品牌，分析它们在烘焙和日常使用中的表现。',
    content: '',
    category: '进口黄油推荐',
    categorySlug: 'imported-butter',
    image: 'https://readdy.ai/api/search-image?query=Japanese%20premium%20butter%20packaging%20with%20minimalist%20Japanese%20design%2C%20on%20light%20wood%20surface%2C%20cherry%20blossom%20petal%20accent%2C%20soft%20natural%20lighting%2C%20clean%20cream%20and%20pale%20pink%20aesthetic%2C%20elegant%20food%20photography&width=800&height=500&seq=article-jp-butter&orientation=landscape',
    author: '黄油君',
    publishDate: '2026-07-22',
    readTime: '6',
    tags: ['日本黄油', '进口黄油', '亚洲黄油'],
    rating: 4.4,
  },
  {
    id: '7',
    slug: 'butter-storage-tips',
    title: '黄油怎么保存才正确？冷藏、冷冻还是常温？',
    excerpt: '黄油保存不当不仅影响风味，还可能滋生细菌。本文详细解答黄油保存的各种疑问：开封后能放多久？可以冷冻吗？有盐和无盐黄油的保存方法有区别吗？一篇文章说清楚。',
    content: '',
    category: '家用黄油',
    categorySlug: 'home-butter',
    image: 'https://readdy.ai/api/search-image?query=Butter%20stored%20in%20different%20containers%20and%20wraps%20on%20kitchen%20counter%2C%20butter%20dish%20with%20lid%2C%20organized%20kitchen%20storage%2C%20warm%20natural%20lighting%2C%20cream%20and%20beige%20color%20scheme%2C%20practical%20home%20kitchen%20photography&width=800&height=500&seq=article-storage&orientation=landscape',
    author: '黄油君',
    publishDate: '2026-07-20',
    readTime: '5',
    tags: ['黄油保存', '厨房技巧', '家用黄油'],
    rating: 4.3,
  },
  {
    id: '8',
    slug: 'organic-butter-worth-it',
    title: '有机黄油值得买吗？有机 vs 普通黄油全面对比',
    excerpt: '有机黄油价格通常是普通黄油的两到三倍，它到底贵在哪里？我们分析了有机认证标准、奶源差异和营养价值，帮你判断有机黄油是否值得这个价格。',
    content: '',
    category: '黄油选购指南',
    categorySlug: 'buying-guide',
    image: 'https://readdy.ai/api/search-image?query=Organic%20butter%20with%20certification%20labels%20next%20to%20fresh%20green%20pasture%20and%20happy%20cows%20in%20background%20blur%2C%20natural%20farm%20setting%2C%20warm%20sunlight%2C%20cream%20and%20green%20tones%2C%20authentic%20farm%20photography%20style&width=800&height=500&seq=article-organic-butter&orientation=landscape',
    author: '黄油君',
    publishDate: '2026-07-18',
    readTime: '6',
    tags: ['有机黄油', '黄油对比', '选购指南'],
    rating: 4.5,
  },
  {
    id: '9',
    slug: 'butter-croissant-baking',
    title: '做可颂用什么黄油？起酥黄油选购与使用技巧',
    excerpt: '可颂对黄油的要求极高——延展性、熔点、乳脂含量都直接影响成品层次。本文专为面包爱好者准备，详解起酥黄油的选购要点，推荐适合做可颂的黄油品牌。',
    content: '',
    category: '烘焙黄油推荐',
    categorySlug: 'baking-butter',
    image: 'https://readdy.ai/api/search-image?query=Freshly%20baked%20golden%20croissants%20on%20cooling%20rack%2C%20butter%20block%20and%20rolling%20pin%20nearby%2C%20flaky%20layers%20visible%2C%20warm%20morning%20light%2C%20French%20bakery%20atmosphere%2C%20cream%20and%20golden%20brown%20tones%2C%20artisan%20baking%20photography&width=800&height=500&seq=article-croissant&orientation=landscape',
    author: '黄油君',
    publishDate: '2026-07-15',
    readTime: '8',
    tags: ['起酥黄油', '可颂', '烘焙技巧', '法式面包'],
    rating: 4.7,
  },
];